import { Component, OnInit, ViewChild, ElementRef, AfterViewInit, AfterViewChecked } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UserInformationService } from '../../services/user-information.service';

declare var $: any;
declare var Waves: any;

@Component({
    selector: "sidebar",
    templateUrl: "./sidebar.component.html",
    styleUrls: ["./sidebar.component.css"]
})
export class SidebarComponent implements OnInit, AfterViewInit, AfterViewChecked {
    public menu: any[] = [];
    public alertSubMenu: any[] = [];
    public userInfoSubMenu: any[] = [];

    constructor(private route: ActivatedRoute, private userInformationService: UserInformationService) {

    }
    ngOnInit() {
        if (this.route.snapshot.data["main"]) {
            this.route.data
                .subscribe(data => {
                    if (data['main'][2].length > 0) {
                        this.menu.push({
                            ALLOW_PATIENT: null,
                            ALLOW_PROVIDER: true,
                            IS_ACTIVE: null,
                            MENU_ID: 69,
                            MENU_TEXT: "User",
                            MENU_VALUE: "NOTHING",
                            SORTING_ORDER: null,
                            UMR_ : [],
                            icon: "fa fa-bell",
                            items: [],
                            label: "User",
                            url: "/User"
                        });
                        const hasAlertSubmenu = ['Alert Network'];
                        const hasUserInfoSubmenu = ['User'];
                        const alertSubmenus = this.alertSubMenu;
                        const userInfoSubMenus = this.userInfoSubMenu;
                        const alertSubmenuValues = ['ADAN07', 'ADAN08', 'ADAN09', 'ADAN10', 'ADAN11'];
                        const userInfoSubmenuValues = ['ADUI14', 'ADUI12', 'ADUS01', 'ADCP13', 'DRPC01'];
                        for (const item of data['main'][2]) {
                            if (alertSubmenuValues.lastIndexOf(item.MENU_VALUE) > -1) {
                                alertSubmenus.push(item);
                            } else if (userInfoSubmenuValues.lastIndexOf(item.MENU_VALUE) > -1) {
                                userInfoSubMenus.push(item);
                            } else {
                                this.menu.push(item);
                            }
                        }
                    }
                })
        }
    }
    ngAfterViewInit() {
        $.UMRPortals = {};
        $.UMRPortals.options = {
            leftSideBar: {
                scrollColor: 'rgba(0,0,0,0.5)',
                scrollWidth: '4px',
                scrollAlwaysVisible: false,
                scrollBorderRadius: '0',
                scrollRailBorderRadius: '0'
            },
        }
        /* Left Sidebar - Function =================================================================================================
        *  You can manage the left sidebar menu options
        *  
        */
        $.UMRPortals.leftSideBar = {
            activate: function () {
                var _this = this;
                var $body = $('body');
                var $overlay = $('.overlay');
                //Close sidebar
                $(window).click(function (e) {
                    var $target = $(e.target);
                    if (e.target.nodeName.toLowerCase() === 'i') { $target = $(e.target).parent(); }

                    if (!$target.hasClass('bars') && _this.isOpen() && $target.parents('#leftsidebar').length === 0) {
                        if (!$target.hasClass('js-right-sidebar')) $overlay.fadeOut();
                        $body.removeClass('overlay-open');
                    }
                });

                $.each($('.menu-toggle.toggled'), function (i, val) {
                    $(val).next().slideToggle(0);
                });

                //When page load
                $.each($('.menu .list li.active'), function (i, val) {
                    var $activeAnchors = $(val).find('a:eq(0)');

                    $activeAnchors.addClass('toggled');
                    $activeAnchors.next().show();
                });

                //Set menu height
                _this.setMenuHeight();
                _this.checkStatuForResize(true);
                $(window).resize(function () {
                    _this.setMenuHeight();
                    _this.checkStatuForResize(false);
                });
            },
            setMenuHeight: function () {
                if (typeof $.fn.slimScroll != 'undefined') {
                    var configs = $.UMRPortals.options.leftSideBar;
                    var height = ($(window).height() - ($('.legal').outerHeight() + $('.user-info').outerHeight() + $('.navbar').innerHeight()));
                    var $el = $('.list');

                    $el.slimScroll({ destroy: true }).height("auto");
                    $el.parent().find('.slimScrollBar, .slimScrollRail').remove();

                    $el.slimscroll({
                        height: height + "px",
                        color: configs.scrollColor,
                        size: configs.scrollWidth,
                        alwaysVisible: configs.scrollAlwaysVisible,
                        borderRadius: configs.scrollBorderRadius,
                        railBorderRadius: configs.scrollRailBorderRadius
                    });
                }
            },
            checkStatuForResize: function (firstTime) {
                var $body = $('body');
                var $openCloseBar = $('.navbar .navbar-header .bars');
                var width = $body.width();

                if (firstTime) {
                    $body.find('.content, .sidebar').addClass('no-animate').delay(1000).queue(function () {
                        $(this).removeClass('no-animate').dequeue();
                    });
                }

                if (width < 1170) {
                    $body.addClass('ls-closed');
                    $openCloseBar.fadeIn();
                }
                else {
                    $body.removeClass('ls-closed');
                    $openCloseBar.fadeOut();
                }
            },
            isOpen: function () {
                return $('body').hasClass('overlay-open');
            }
        };

        $(function () {
            $.UMRPortals.leftSideBar.activate();
            setTimeout(function () { $('.page-loader-wrapper').fadeOut(); }, 50);
        });
    }
    hideMenu() {
        let $body = $('body');
        let width = $body.width();
        if (width < 1170) {
            $body.removeClass('overlay-open');
            $('.navbar .navbar-header .bars').fadeIn();
        }
    }
    ngAfterViewChecked() {
        //Set Waves
        Waves.attach('.menu .list a', ['waves-block']);
        Waves.init();
    }
    menuToggle(menuNode, menu) {
        if ($("#" + menu).hasClass('toggled')) {
            $("#" + menu).removeClass('toggled');
        } else {
            $("#" + menu).addClass('toggled');
        }
        $("#" + menuNode).slideToggle(320);
    }
}
